import { on } from "svelte/events";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function useRestoreFocus(Host: HTMLElement): () => void {
  let lastFocusedElement: HTMLElement | undefined = $state();

  $effect(() =>
    on(Host, "focusin", (event: FocusEvent) => {
      lastFocusedElement = event.relatedTarget as HTMLElement;
    }),
  );
  $effect(() =>
    on(Host, "focusout", () => {
      lastFocusedElement = undefined;
    }),
  );

  return () => lastFocusedElement?.focus();
}
